import { render, staticRenderFns } from "./PaymentsReviewModal.vue?vue&type=template&id=6b2a9f34&"
import script from "./PaymentsReviewModal.vue?vue&type=script&lang=js&"
export * from "./PaymentsReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsReviewModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports